// src/components/views/ArchiveView.jsx
import { memo } from "react";
import Archive from "../Archive";
import { useToast } from "../../context/ToastContext";
import { TOASTS } from "../../utils/constants";
import { useArchiveDb } from "../../hooks/useDb";
import { isCascadeArchivedTask } from "../../utils/entityState";
import { useRestoreTaskMutation } from "../../api/queries/tasks";
import { useRestoreProjectMutation } from "../../api/queries/projects";

/**
 * Восстановление проекта каскадно восстанавливает его задачи на бэкенде.
 * ArchiveView читает архивные проекты и задачи через useArchiveDb —
 * отдельный набор запросов с includeArchived=true, чтобы не раздувать
 * основной db-кэш активных сущностей. Мутации восстановления
 * инвалидируют PROJECTS_KEY/TASKS_KEY, подхватывая и архивный кэш.
 */
function ArchiveView({ ur, openTask, openProject, setArchiveMonths }) {
  const db = useArchiveDb();
  const { tasks, projects } = db;

  const { showToast } = useToast();

  const restoreTaskMutation = useRestoreTaskMutation();
  const restoreProjectMutation = useRestoreProjectMutation();

  const restoreTask = (id) => {
    const t = tasks.find((x) => x.id === id);
    if (isCascadeArchivedTask(t)) {
      showToast(
        "Задача архивирована вместе с проектом. Сначала восстановите проект.",
        "warning",
      );
      return;
    }

    restoreTaskMutation.mutate(
      { id },
      {
        onSuccess: () => showToast(TOASTS.taskRestored(t.title), "success"),
        onError: (err) =>
          showToast(err.message || "Ошибка восстановления задачи", "error"),
      },
    );
  };

  const restoreProject = (id) => {
    const p = projects.find((x) => x.id === id);

    restoreProjectMutation.mutate(id, {
      onSuccess: () => showToast(TOASTS.projectRestored(p.name), "success"),
      onError: (err) =>
        showToast(err.message || "Ошибка восстановления проекта", "error"),
    });
  };

  return (
    <Archive
      db={db}
      ur={ur}
      openTask={openTask}
      openProject={openProject}
      setArchiveMonths={setArchiveMonths}
      restoreTask={restoreTask}
      restoreProject={restoreProject}
    />
  );
}

export default memo(ArchiveView);
